export const WORDS = [
  "Apple",
  "Ball",
  "Cat",
  "Dog",
  "Egg",
  "Fish",
  "Goat",
  "Hat",
  "Ice",
  "Jug",
  "Kite",
  "Lion",
  "Moon",
  "Nest",
  "Owl",
  "Pen",
  "Queen",
  "Rain",
  "Sun",
  "Tree",
  "Umbrella",
  "Van",
  "Water",
  "Box",
  "Yarn",
  "Zoo",
  "Chair",
  "Table",
  "Book",
  "Fan",
  "Lamp",
  "Bag",
  "Door",
  "Shoe",
  "Wall",
  "Bed",
  "Glass",
  "Plate",
  "Fork",
  "Spoon",
  "Cup",
  "Mug",
  "Cake",
  "Milk",
  "Bread",
  "Rice",
  "Beans",
  "Cheese",
  "Salt",
  "Soap",
  "Brush",
  "Tooth",
  "Comb",
  "Phone",
  "Mouse",
  "Key",
  "Clock",
  "Watch",
  "Leaf",
  "Stone",
  "Stick",
  "Coin",
  "Note",
  "Drum",
  "Bell",
  "Flag",
  "Star",
  "Cloud",
  "Sky",
  "Wind",
  "Fire",
  "Hill",
  "River",
  "Lake",
  "Boat",
  "Car",
  "Bike",
  "Bus",
  "Train",
  "Plane",
  "Road",
  "Park",
  "Tree",
  "Seed",
  "Grass",
  "Fruit",
  "Peach",
  "Mango",
  "Berry",
  "Lemon",
  "Orange",
  "Grape",
  "Melon",
  "Chalk",
  "Board",
  "Pen",
  "Pencil",
  "Ruler",
  "Paper",
  "Bag",
];
